import { useNavigate, useParams } from '@tanstack/react-router';
import { useGetBulkReprocessRun } from '@sara/api-client';
import { BulkReprocessRunDetail, BulkReprocessItemsTable } from '../../contexts/admin';

export function BulkReprocessRunPage() {
  const navigate = useNavigate();
  const { runId } = useParams({ strict: false }) as { runId: string };

  // Shares React Query's cache with BulkReprocessRunDetail's own fetch (same
  // key) — no extra request; used here only to gate the items table's polling.
  const { data: run } = useGetBulkReprocessRun(runId, {
    query: {
      refetchInterval: (query) => (query.state.data?.status === 'RUNNING' ? 3000 : false),
    },
  });
  const isRunActive = run?.status === 'RUNNING' || run?.status === 'PENDING';

  return (
    <div className="flex flex-1 flex-col gap-6">
      <BulkReprocessRunDetail runId={runId} onBack={() => navigate({ to: '/admin/bulk-replay' })} />
      <BulkReprocessItemsTable runId={runId} isRunActive={isRunActive} />
    </div>
  );
}
